import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getRelatedGuests = get('guest.relatedGuests');

export const getRelatedGuestsByField = createSelector(
  getRelatedGuests,
  get('guestsByField')
);

export const getRelatedGuestsForField = createSelector(
  (_, field) => field,
  getRelatedGuestsByField,
  get
);

export const getFetching = createSelector(getRelatedGuests, get('fetching'));

export const getFetched = createSelector(getRelatedGuests, get('fetched'));
